import { Box, Flex, Text, useDisclosure } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import MainLayout from '../../components/mainlayout';
import Topbar from '../../components/topbar';
import Searchbar from '../../components/searchbar';
import CustomSelect from '../../components/select';
import Table from '../../components/table';
import { columns } from './data';
import EditModal from './EditModal';
import useGetSellers from '../../api/queries/useGetSellers';
const SellerRequests = () => {
  const {
    isOpen: isEditOpen,
    onOpen: onEditOpen,
    onClose: onEditClose,
  } = useDisclosure();
  const [productsData, setProductsData] = useState([]);
  const [statusFilter, setStatusFilter] = useState('');
  const [sort, setSort] = useState('desc');
  const [search, setSearch] = useState('');
  const [selectedSeller, setSelectedSeller] = useState(null);

  const { data, isLoading, error } = useGetSellers({
    page: 1,
    limit: 10000000,
    sortColumn: 'date_created',
    sortOrder: sort,
    status: statusFilter,
    search: search,
    searchObject: {
      country: '',
      is_verified: '',
    },
  });

  useEffect(() => {
    if (data) {
      const filteredData = (data?.data || []).filter(seller => {
        const role = seller?.authUser?.role;
        return role !== 'employee' && role !== 'owner';
      });
      setProductsData(filteredData);
    }
  }, [data]);

  console.log('Data', data);
  return (
    <MainLayout h={'100%'} minH={'100vh'} paddingBottom={20}>
      <Box>
        <Topbar title={'Seller Requests'} />
        <Flex
          bg={'#f8fbff'}
          padding={4}
          height={'100%'}
          gap={2}
          justifyContent={'space-between'}
          alignItems={'center'}
        >
          <Flex align={'center'}>
            <Searchbar title="Search" onChange={value => setSearch(value)} />
          </Flex>
          <Flex justify={'space-between'} alignItems={'center'}>
            <Flex gap={3}>
              {/* <CustomSelect
                label={'Filter by Location'}
                //   onChange={setSort}
                style={{ maxWidth: '200px' }}
                inputStyle={{
                  border: 'none',
                  background: '#fff',
                  color: '#898989',
                  fontSize: '14px',
                  fontFamily: 'PlusJakartaSansMedium',
                }}
              >
                <option value={''}>Select Location</option>
                <option value={''}>Hendon</option>
                <option value={''}>Bicestor Village</option>
                <option value={''}>London</option>
              </CustomSelect> */}
              <CustomSelect
                label={'Filter by Status'}
                onChange={value => {
                  const booleanStatus =
                    value === 'true' ? true : value === 'false' ? false : '';
                  setStatusFilter(booleanStatus);
                }}
                style={{ maxWidth: '250px' }}
                inputStyle={{
                  border: 'none',
                  background: '#fff',
                  color: '#898989',
                  fontSize: '14px',
                  fontFamily: 'PlusJakartaSansMedium',
                }}
              >
                <option value="">Select Status</option>
                <option value="true">Approved</option>
                <option value="false">Pending</option>
              </CustomSelect>

              <CustomSelect
                label={'Sort'}
                onChange={value => {
                  const order = value === 'newest' ? 'desc' : 'asc';
                  setSort(order);
                }}
                style={{ maxWidth: '200px' }}
                inputStyle={{
                  border: 'none',
                  background: '#fff',
                  color: '#898989',
                  fontSize: '14px',
                  fontFamily: 'PlusJakartaSansMedium',
                }}
              >
                <option value={'newest'}>Newest First</option>
                <option value={'oldest'}>Oldest First</option>
              </CustomSelect>
            </Flex>
          </Flex>
        </Flex>
        {isLoading ? (
          <Box p={8}>Loading Seller Requests...</Box>
        ) : (
          <Box minW={'100%'} w={'1px'} overflowX={'auto'}>
            <Table
              data={productsData}
              columns={columns({
                onEditOpen: row => {
                  setSelectedSeller(row);
                  onEditOpen();
                },
              })}
            />
          </Box>
        )}

        <EditModal
          isOpen={isEditOpen}
          onClose={onEditClose}
          data={selectedSeller}
        />
      </Box>
    </MainLayout>
  );
};
export default SellerRequests;
